import React from 'react';
import BadgeConfig from '../../shared/BadgeConfig';
import { BaseConfig } from '../BaseConfig';
import { Windows } from '../../pages/MainPage';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

import './EndLevelUI.css'

const EndLevelUI = (props: UIProperties<EndLevelUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container" style={{pointerEvents: 'all'}}>
			<div tabIndex={0} id='end-level-ui-first' aria-label='End of level' style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '1290px',
				height: '750px'
			}}>
				<img style={{
					position: 'absolute',
					zIndex: -1
				}} src="./assets/images/general/backgrounds/level-completed.png"/>

				<p tabIndex={0} className="title-font" style={{
					color: 'rgb(23, 208, 0)',
					position: 'absolute',
					margin: '0',
					top: '70px',
					width: '100%',
					textAlign: 'center',
					fontSize: '100pt'
				}}>Great Job!</p>

				<p tabIndex={0} className="title-font" style={{
					position: 'absolute',
					margin: '0',
					top: '230px',
					width: '100%',
					textAlign: 'center',
					fontSize: '50pt'
				}}>{'Level ' + (props.parameters.level + 1) + ' Complete'}</p>

				<p tabIndex={0} className="title-font" style={{
					color: 'rgb(239, 243, 166)',
					position: 'absolute',
					margin: '0',
					top: '340px',
					fontSize: '30pt',
					textAlign: 'center',
					width: '100%'
				}}>You have earned the following badges</p>

				<div style={{
					    display: 'inline-grid',
						//width: '1230px',
						height: '200px',
						gridTemplateColumns: (() => {
							var result = '';
							var length = 1;

							// if(props.parameters.badges.length >= 3) {
							// 	length = 3;
							// } else {
								length = props.parameters.badges.length;
							// }

							for(var indx = 0; indx < length; indx++) {
								result += 'auto ';
							}
							
							return result;
						})(),
						gridTemplateRows: (() => {
							var result = '';
							var length = 1;
							var maxSize = 200;

							// if(props.parameters.badges.length <= 3) {
							// 	length = 1;
							// } else if(props.parameters.badges.length <= 6) {
							// 	length = 2;
							// } else {
							// 	length = 3;
							// }

							for(var indx = 0; indx < length; indx++) {
								result += (maxSize / length) + 'px ';
							}
							
							return result;
						})(),
						position: 'absolute',
						left: '50%',
    					transform: 'translate(-50%, 0px)',
						top: '390px'
				}}>
					{props.parameters.badges.filter((a: BadgeConfig) => a.isUnlocked).map((b: any, index: number) => {
						return (<img style={{
							maxWidth: 'none',
    						maxHeight: '100%'
						}} tabIndex={0} aria-label={b.title} key={index} src={b.unlockedImage} alt="" />);
					})}
				</div>

				<GeneralButtonWithText parameters= {{
					text: 'Exit Game',
					top: '612px',
					left: '350px',
					width: '413.33px',
					onClicked: () => {
						props.parameters.updateWindow(Windows.MainMenu);
					}
				}}/>

				<GeneralButtonWithText parameters= {{
					text: 'Next Level',
					top: '612px',
					left: '710px',
					width: '413.33px',
					id: 'end-level-ui-last',
					onClicked: () => {
						props.parameters.updateWindow(props.parameters.level + 3);
					}
				}}/>
			</div>
			
		</div>
	);

};

export interface EndLevelUIConfig extends BaseConfig {
	level: number;
	badges: BadgeConfig[];
	updateWindow: (windowToUse: Windows) => void;
	onExitGameClicked: () => void;
	onNextLevelClicked: () => void;
}

export default EndLevelUI;